import FileIcon from '@mui/icons-material/FileDownload';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { useTranslate } from 'react-admin';

interface TemplateDownloadLinksProps {
  onDownloadWithMacro: () => Promise<void>;
  onDownloadWithoutMacro: () => Promise<void>;
}

export function TemplateDownloadLinks({
  onDownloadWithMacro,
  onDownloadWithoutMacro,
}: TemplateDownloadLinksProps) {
  const translate = useTranslate();

  return (
    <Stack spacing={1}>
      <Link
        href="#"
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();
          await onDownloadWithMacro();
        }}
        rel="noreferrer"
        underline="hover"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
        }}>
        <FileIcon sx={{ fontSize: 20 }} />
        {translate(
          'resources.bo_common.b2b.employees.actions.bulk_create.download_template_with_macro',
        )}
      </Link>
      <Link
        href="#"
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();
          await onDownloadWithoutMacro();
        }}
        rel="noreferrer"
        underline="hover"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
        }}>
        <FileIcon sx={{ fontSize: 20 }} />
        {translate(
          'resources.bo_common.b2b.employees.actions.bulk_create.download_template_without_macro',
        )}
      </Link>
    </Stack>
  );
}
